import React from 'react';
import { Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import { FaSearch, FaFilter, FaTimes } from 'react-icons/fa';

/**
 * Componente para los filtros de planillas
 */
const PlanillasFilters = ({
  searchTerm,
  setSearchTerm,
  filtroEstado,
  setFiltroEstado,
  fechaInicioFiltro,
  setFechaInicioFiltro,
  fechaFinFiltro,
  setFechaFinFiltro,
  onLimpiarFiltros
}) => {
  return (
    <div className="mb-4 p-4 border rounded-3 bg-light bg-opacity-50">
      <Row className="g-3 align-items-end">
        {/* Búsqueda por período */}
        <Col md={3}>
          <Form.Group>
            <Form.Label className="small fw-bold text-muted mb-1 text-uppercase">Búsqueda</Form.Label>
            <InputGroup>
              <InputGroup.Text className="bg-white border-end-0">
                <FaSearch className="text-muted" />
              </InputGroup.Text>
              <Form.Control
                className="border-start-0"
                type="text"
                placeholder="Período (YYYY-MM)"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ borderRadius: "0 8px 8px 0" }}
              />
            </InputGroup>
          </Form.Group>
        </Col>

        {/* Filtro por estado */}
        <Col md={2}>
          <Form.Group>
            <Form.Label className="small fw-bold text-muted mb-1 text-uppercase">Estado</Form.Label>
            <Form.Select
              value={filtroEstado}
              onChange={(e) => setFiltroEstado(e.target.value)}
              style={{ borderRadius: "8px" }}
            >
              <option value="TODOS">Todos los estados</option>
              <option value="BORRADOR">Borrador</option>
              <option value="PROCESADO">Procesado</option>
              <option value="APROBADO">Aprobado</option>
              <option value="ANULADO">Anulado</option>
            </Form.Select>
          </Form.Group>
        </Col>

        {/* Filtro por fecha inicio */}
        <Col md={2}>
          <Form.Group>
            <Form.Label className="small fw-bold text-muted mb-1 text-uppercase">Deste</Form.Label>
            <Form.Control
              type="date"
              value={fechaInicioFiltro}
              onChange={(e) => setFechaInicioFiltro(e.target.value)}
              style={{ borderRadius: "8px" }}
            />
          </Form.Group>
        </Col>

        {/* Filtro por fecha fin */}
        <Col md={2}>
          <Form.Group>
            <Form.Label className="small fw-bold text-muted mb-1 text-uppercase">Hasta</Form.Label>
            <Form.Control
              type="date"
              value={fechaFinFiltro}
              onChange={(e) => setFechaFinFiltro(e.target.value)}
              style={{ borderRadius: "8px" }}
            />
          </Form.Group>
        </Col>

        {/* Botón limpiar filtros */}
        <Col md={3}>
          <Button
            variant="outline-secondary"
            onClick={onLimpiarFiltros}
            className="w-100 d-flex align-items-center justify-content-center gap-2 shadow-sm"
            style={{ borderRadius: "8px", height: "40px", fontWeight: "bold" }}
          >
            <FaTimes /> Limpiar Filtros
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default PlanillasFilters;